import {Injectable} from '@angular/core';
import {BaseOPEService} from "./BaseOPEService";
import {GetGatewayTypesCB} from "../../ope/gateway-type/GetGatewayTypesCB";
import {PutGatewayTypeCB} from "../../ope/gateway-type/PutGatewayTypeCB";
import {DelGatewayTypeCB} from "../../ope/gateway-type/DelGatewayTypeCB";

@Injectable({
  providedIn: 'root'
})
export class GatewayTypeOpeService extends BaseOPEService {
  public getGatewayTypes(cb: GetGatewayTypesCB): Promise<any> {
    return this.execOPE(cb);
  }

  public putGatewayType(cb: PutGatewayTypeCB): Promise<any> {
    return this.execOPE(cb);
  }

  public delGatewayType(cb: DelGatewayTypeCB): Promise<any> {
    return this.execOPE(cb);
  }
}
